import 'custom-event-polyfill'
import { analyticsMap, AnalyticsEvent } from './constants'
import buildErrorPageAnalytics from './buildErrorPageAnalytics'

const events: CustomEvent[] = []

const dispatchNewEvent = (action = 'pageload'): void => {
  const event = new window.CustomEvent('dataStateChange', { detail: { action } })
  if (document.readyState === 'complete') {
    document.body.dispatchEvent(event)
  } else {
    events.push(event)
    document.onreadystatechange = (): void => {
      if (document.readyState === 'complete') {
        events.forEach(event => {
          const delay = event.detail.action === 'pageload' ? 0 : 1000
          setTimeout(() => document.body.dispatchEvent(event), delay)
        })
      }
    }
  }
}

const updateDataLayer = (data = {}): void => {
  if (window.jlData) delete window.jlData.error
  window.jlData = {
    ...window.jlData,
    ...data,
  }
}

export const triggerEvent = (event: AnalyticsEvent): void => {
  const data = analyticsMap[event]
  updateDataLayer(data)
  dispatchNewEvent()
}

export const triggerErrorEvent = (message: string): void => {
  const data = {
    error: {
      type: 'sso:system',
      message,
    },
  }
  updateDataLayer(data)
  dispatchNewEvent('error')
}

export const triggerErrorPageLoadEvent = (message: string): void => {
  const data = buildErrorPageAnalytics(message)
  updateDataLayer(data)
  dispatchNewEvent()
}
